var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-input-message-wrapper",class:_vm.customClassWrapper,attrs:{"id":_vm.idName}},[_c('img',{attrs:{"src":"/images/ics_f_warning_triangles_red.svg","alt":"warning icon"}}),_vm._v(" "),_c('p',{class:_vm.customClassP,domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }